import React, {useState} from "react";
import { IDSInput, IDSButton } from '@inera/ids-react';
import StatusAlert from '../StatusAlert';
import { createOrganisation } from '../../services/organisationsAdminAPI';
import { validateOrganisation } from '../../utils/adminValidation';


const CreateOrganisationLayout = () => {
    const [formData, setFormData] = useState({
        organisationName: '',
        organisationDomain: '',
        organisationHsaId: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear field error when user starts typing
        if (fieldErrors[name]) {
            setFieldErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);

        const errors = validateOrganisation(
            {
                name: formData.organisationName,
                domain: formData.organisationDomain,
                hsaId: formData.organisationHsaId,
            },
            { requireDomain: true, requireHsaId: true }
        );
        setFieldErrors({
            organisationName: errors.name || null,
            organisationDomain: errors.domain || null,
            organisationHsaId: errors.hsaId || null,
        });
        if (Object.keys(errors).length > 0) return;

        setLoading(true);
        setError(null);

        try {
            await createOrganisation({
                organisationName: formData.organisationName.trim(),
                organisationDomain: formData.organisationDomain.trim(),
                organisationHsaId: formData.organisationHsaId.trim(),
            });

            setSuccess(true);
            setFormData({
                organisationName: '',
                organisationDomain: '',
                organisationHsaId: ''
            });
        } catch (err) {
            if (err.errorCode === 'MIMIR-3002') {
                setFieldErrors(prev => ({ ...prev, organisationName: err.message }));
            } else {
                setError(err.message || "Något gick fel. Försök igen.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <main className="ids-content ids-p-6" style={{ maxWidth: '600px', margin: '2rem auto' }}>
                <h1 className="ids-heading-l ids-mb-6">Skapa Organisation</h1>

                <StatusAlert error={error} success={success ? 'Organisation skapad!' : null} />

                <form onSubmit={handleSubmit} noValidate>
                    <div className="ids-mb-4">
                        <IDSInput
                            label="Namn *"
                            type="text"
                            id="organisationName"
                            name="organisationName"
                            invalid={!!fieldErrors.organisationName}
                            errorMsg={fieldErrors.organisationName}
                            value={formData.organisationName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="ids-mb-4">
                        <IDSInput
                            label="Domän *"
                            type="text"
                            id="organisationDomain"
                            name="organisationDomain"
                            invalid={!!fieldErrors.organisationDomain}
                            errorMsg={fieldErrors.organisationDomain}
                            value={formData.organisationDomain}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="ids-mb-4">
                        <IDSInput
                            label="HSA ID *"
                            type="text"
                            id="organisationHsaId"
                            name="organisationHsaId"
                            invalid={!!fieldErrors.organisationHsaId}
                            errorMsg={fieldErrors.organisationHsaId}
                            value={formData.organisationHsaId}
                            onChange={handleInputChange}
                            placeholder="T.ex. SE165565594230-1003"
                        />
                        <p style={{ fontSize: '0.8rem', color: 'var(--ids-palette-neutral-50)', marginTop: '0.25rem' }}>
                            Organisationens HSA-ID börjar med SE följt av organisationsnumret och ett enhetsnummer.
                        </p>
                    </div>

                    <IDSButton size="m" disabled={loading} type="submit">
                        {loading ? 'Skapar...' : 'Skapa'}
                    </IDSButton>
                </form>
            </main>
        </div>
    );
}
export default CreateOrganisationLayout;
